import React from "react";
import "../css/CryptoHero.css";

// Иконки Bootstrap
import { 
  FileEarmarkCheck, 
  Building, 
  Bank, 
  PersonCheck, 
  Flag, 
  GraphUp, 
  Laptop, 
  Phone,
  People
} from "react-bootstrap-icons";

// SVG иконки (замени на свои)
import iconRegulation from "../images/icons/regulation.svg";
import iconInstitutional from "../images/icons/institutional.svg";
import iconInnovation from "../images/icons/innovation.svg";
import iconAdoption from "../images/icons/adoption.svg";

const USCryptoAchievements = () => {
  return (
    <div className="box">
      <section className="_usa-crypto">
        <canvas className="particles-canvas" id="particlesCanvas"></canvas>

        <div className="container">
          {/* Верхний блок — 4 ключевых достижения */}
          <div className="achievements">
            <h3>
              USA's <span>Crypto Revolution</span>
              <br />
              <small>2023 — 2026: Three Years That Changed Everything</small>
            </h3>
            <div className="cols">
              <div className="col">
                <img src={iconRegulation} alt="Regulation" />
                <span>Clear Regulatory Framework</span>
                <p>FIT21 Act passed — first comprehensive crypto legislation</p>
              </div>
              <div className="col">
                <img src={iconInstitutional} alt="Institutional" />
                <span>Institutional Gold Rush</span>
                <p>BlackRock, Fidelity, and major banks enter crypto space</p>
              </div>
              <div className="col">
                <img src={iconInnovation} alt="Innovation" />
                <span>Tech Innovation Hub</span>
                <p>NYC, SF, Miami become global crypto development centers</p>
              </div>
              <div className="col">
                <img src={iconAdoption} alt="Adoption" />
                <span>Mass Adoption</span>
                <p>Over 80 million Americans now hold cryptocurrency</p>
              </div>
            </div>
          </div>

          {/* Нижний блок — детальные достижения */}
          <div className="details">
            <h3>
              How <span>America</span> Became the
              <br />
              <span>Global Crypto Leader</span>
            </h3>

            <div className="cols">
              {/* Карточка 1: Регулирование */}
              <div className="col">
                <div className="col-image-placeholder">
                  <Flag size={48} color="#162a6b" />
                </div>
                <h4>
                  Regulatory <span>Clarity</span>
                </h4>
                <p>
                  <span>2024:</span> The Financial Innovation and Technology for
                  the 21st Century Act (FIT21) passes with bipartisan support —
                  the first major crypto legislation in US history.
                </p>
                <p>
                  <span>2025:</span> SEC and CFTC establish joint framework,
                  ending years of regulatory uncertainty. Crypto firms finally
                  have clear rules to operate under.
                </p>
                <p>
                  <span>2026:</span> Over 40 states pass blockchain-friendly
                  legislation, with Wyoming and Texas leading the charge.
                </p>
              </div>

              {/* Карточка 2: Институциональные инвестиции */}
              <div className="col">
                <div className="col-image-placeholder">
                  <Bank size={48} color="#162a6b" />
                </div>
                <h4>
                  Wall Street <span>Embraces</span> Crypto
                </h4>
                <p>
                  <span>2024:</span> Bitcoin spot ETFs approved — BlackRock's iShares
                  Bitcoin Trust becomes the fastest-growing ETF in history,
                  reaching <span>$50B</span> AUM in just 6 months.
                </p>
                <p>
                  <span>2025:</span> Major banks including JPMorgan, Goldman Sachs,
                  and Citi launch crypto custody services. <span>$300B+</span> in
                  institutional capital flows into digital assets.
                </p>
                <p>
                  <span>2026:</span> Pension funds and endowments begin allocating
                  2-5% to crypto, marking the final stage of institutional adoption.
                </p>
              </div>

              {/* Карточка 3: Технологические инновации */}
              <div className="col">
                <div className="col-image-placeholder">
                  <Laptop size={48} color="#162a6b" />
                </div>
                <h4>
                  Innovation <span>Ecosystem</span>
                </h4>
                <p>
                  <span>2023-2024:</span> New York, San Francisco, and Miami
                  emerge as global crypto hubs, attracting <span>$15B+</span> in
                  VC funding for blockchain startups.
                </p>
                <p>
                  <span>2025:</span> US companies lead development of zero-knowledge
                  proofs, layer-2 scaling, and AI-integrated smart contracts.
                </p>
                <p>
                  <span>2026:</span> Over <span>5,000</span> blockchain patents
                  filed by US-based companies — more than China and Europe combined.
                </p>
              </div>

              {/* Карточка 4: Массовое принятие */}
              <div className="col">
                <div className="col-image-placeholder">
                  <People size={48} color="#162a6b" />
                </div>
                <h4>
                  Mass <span>Adoption</span> Across America
                </h4>
                <p>
                  <span>2024:</span> Crypto ownership reaches <span>60M</span> Americans
                  — 1 in 5 adults now hold digital assets. Retail adoption
                  accelerates through apps like CashApp, Robinhood, and PayPal.
                </p>
                <p>
                  <span>2025:</span> Over <span>100,000</span> US businesses accept
                  crypto payments. Major retailers including Walmart, Target, and
                  Home Depot integrate crypto checkout options.
                </p>
                <p>
                  <span>2026:</span> <span>80M+</span> Americans hold crypto. The
                  "digital dollar" conversation shifts from "if" to "when" as the
                  US moves closer to a CBDC framework.
                </p>
              </div>
            </div>
          </div>

          {/* Бонусный блок: статистика */}
          <div className="stats-banner">
            <div className="stat-item">
              <span className="stat-number">80M+</span>
              <span className="stat-label">Americans Hold Crypto</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">$50B+</span>
              <span className="stat-label">Bitcoin ETF Inflows (2024-25)</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">15,000+</span>
              <span className="stat-label">Blockchain Jobs Created</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">40+</span>
              <span className="stat-label">States with Crypto Laws</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default USCryptoAchievements;